const dropdownIds = ["voucher", "payment", "technical", "tradein", "shipping"];

function toggleDropdown(id) {
    const dropdown = document.getElementById(`dropdown-${id}`);
    const arrow = document.getElementById(`arrow-${id}`);
    const isCurrentlyOpen = !dropdown.classList.contains("hidden");

    document.querySelectorAll(".dropdown-content").forEach((el) => el.classList.add("hidden"));
    document.querySelectorAll(".arrow").forEach((el) => el.classList.remove("rotate"));

    dropdown.classList.toggle("hidden", isCurrentlyOpen);
    arrow.classList.toggle("rotate", !isCurrentlyOpen);
}

function updateMoreInfoSection() {
    setTimeout(() => {
        fetch(window.location.href, { cache: "no-store" })
            .then(response => response.text())
            .then(text => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(text, "text/html");
                let updatedInfo = doc.querySelector(".more-info-container");

                if (updatedInfo) {
                    document.querySelector(".more-info-container").innerHTML = updatedInfo.innerHTML;
                }
            })
            .catch(error => console.error("Error updating More Info section:", error));
    }, 200);
}
